import { render, staticRenderFns } from "./card-dialog.vue?vue&type=template&id=597d8e3f&scoped=true&"
import script from "./card-dialog.vue?vue&type=script&lang=js&"
export * from "./card-dialog.vue?vue&type=script&lang=js&"
import style0 from "./card-dialog.vue?vue&type=style&index=0&id=597d8e3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d8e3f",
  null
  
)

export default component.exports